import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { DUO_IMAGE, PRICE, COMPARE_PRICE, formatPrice } from "../data/products";
import { useStore } from "../context/StoreContext";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

const Hero = () => {
  const { t } = useStore();

  return (
    <section className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-8 px-4 pb-12 pt-32 sm:px-6 lg:grid-cols-2 lg:gap-12 lg:pb-20 lg:pt-40" data-testid="hero-section">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="order-2 lg:order-1">
        <p className="accent-text mb-3 text-xs font-bold uppercase tracking-[0.25em]" data-testid="hero-eyebrow">{t.hero.eyebrow}</p>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl" data-testid="hero-headline">{t.hero.title}</h1>
        <p className="mt-5 max-w-lg text-base text-[var(--muted)] sm:text-lg" data-testid="hero-sub">{t.hero.sub}</p>

        <div className="mt-6 flex items-baseline gap-3">
          <span className="text-sm text-[var(--muted)]">{t.hero.from}</span>
          <span className="font-display text-4xl" data-testid="hero-price">{formatPrice(PRICE)}</span>
          <span className="text-sm text-[var(--muted)] line-through" data-testid="hero-price-compare">{formatPrice(COMPARE_PRICE)}</span>
          <span className="text-xs text-[var(--muted)]">{t.hero.perTub}</span>
        </div>

        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <button data-testid="hero-cta" onClick={() => scrollTo("product")} className="btn-primary flex items-center justify-center gap-2 px-7 py-3.5 text-base">
            {t.hero.cta} <ArrowRight className="h-4 w-4" />
          </button>
          <button data-testid="hero-cta-secondary" onClick={() => scrollTo("ingredients")} className="btn-outline flex items-center justify-center px-7 py-3.5 text-base">
            {t.hero.cta2}
          </button>
        </div>
      </motion.div>

      <motion.div initial={{ opacity: 0, scale: 0.97 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.7 }} className="order-1 lg:order-2">
        <img src={DUO_IMAGE} alt="ZENKAI Pre-Workout Tropical Fury en Wild Apple" className="w-full rounded-sm" data-testid="hero-image" />
      </motion.div>
    </section>
  );
};

export default Hero;
